"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@rradar/core");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var WizardNavigationButtons = function (_a) {
    var previousPath = _a.previousPath, nextPath = _a.nextPath, _b = _a.disableNext, disableNext = _b === void 0 ? false : _b;
    var navigate = (0, react_router_dom_1.useNavigate)();
    return (React.createElement("div", { className: "link_navigation flex-row" },
        React.createElement(core_1.Button, { buttonType: "primary", onClick: function () { return navigate(previousPath); } }, "Previous"),
        React.createElement(core_1.Button, { buttonType: "primary", onClick: function () { return navigate(nextPath); }, disabled: disableNext }, "Next")));
};
exports.default = WizardNavigationButtons;
